import { tasOccurrence } from "../types";

interface Props {
    type: string;
}

const Chip = ({ type }: Props) => {
    const config = {
        "TECHNICAL_SUPPORT": {
            bg: '#F0F9FF',
            color: '#026AA2',
            borderColor: '#B9E6FE',
            text: 'TAS',
        },
        "VOLKSTOTAL": {
            bg: '#F9FAFB',
            color: '#344054',
            borderColor: '#E4E7EC',
            text: 'Volkstotal',
        }
    }

    const result = config[type as keyof typeof config] || config?.VOLKSTOTAL;

    return (
        <div className="height-22 rounded-lg border display-flex justify-content-center" style={{ background: result.bg, color: result.color, borderColor: result.borderColor, padding: '2px 14px', borderRadius: 16, textAlign: 'center' }}>
            <span className="text-size-12 text-medium">{result?.text}</span>
        </div>
    );
};

export default Chip;